var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7885 4.76819L16.5098 12L23.7885 19.2318C23.92 18.9568 23.9999 18.6528 23.9999 18.3281V5.67189C23.9999 5.34719 23.92 5.0432 23.7885 4.76819Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.891 3.5625H2.10976C1.78505 3.5625 1.48107 3.64233 1.20605 3.77391L10.509 13.03C11.3316 13.8526 12.6692 13.8526 13.4918 13.03L22.7947 3.77391C22.5197 3.64233 22.2157 3.5625 21.891 3.5625Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.211406 4.76819C0.0798281 5.0432 0 5.34719 0 5.67189V18.3281C0 18.6528 0.0798281 18.9569 0.211406 19.2318L7.49011 12L0.211406 4.76819Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.516 12.9943L14.486 14.0242C13.1154 15.3948 10.8853 15.3948 9.5147 14.0242L8.48476 12.9943L1.20605 20.2261C1.48107 20.3577 1.78505 20.4375 2.10976 20.4375H21.891C22.2157 20.4375 22.5197 20.3577 22.7947 20.2261L15.516 12.9943Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.bcd008b6226fd0ea806af6dd9a6d11f1.svg";
export { ForwardRef as ReactComponent };